module.exports = __webpack_public_path__ + "static/media/errorimg.4cf87607.png";